import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Spacing } from "folksam-ui";
import useScrollTo from "../../hooks/useScrollTo";

import StepBodyBg from "./StepBodyBg";
import { useTracking } from "hooks/useTracking";

const StepBody = ({ children, id, index, location }) => {
  useScrollTo(id);
  const { datalayer } = window;
  const { track } = useTracking(datalayer);

  useEffect(() => {
    if (datalayer !== undefined) {
      track(`claim_step_${index + 1}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datalayer]);

  return (
    <StepBodyBg>
      <Spacing y={"md"}>{children}</Spacing>
    </StepBodyBg>
  );
};

StepBody.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default withRouter(StepBody);
